import * as tslib_1 from "tslib";
import { observable } from 'mobx';
import { getNfcViewOptionFilter } from './NfcTaskViewOptions';
var NfcTaskFilter = /** @class */ (function () {
    function NfcTaskFilter(userStore) {
        var _this = this;
        this.userStore = userStore;
        this.viewOption = '';
        this.applyOn = function (tasks) {
            if (!tasks || tasks.length === 0) {
                return [];
            }
            return tasks
                .filter(function (i) { return !_this.userStore.loggedInUserIsAdmin || getNfcViewOptionFilter(_this.viewOption)(i, _this.userStore); });
        };
    }
    NfcTaskFilter.prototype.setValue = function (key, value) {
        var _a;
        if (key in this) {
            Object.assign(this, (_a = {}, _a[key] = value, _a));
        }
    };
    NfcTaskFilter.prototype.clear = function () {
        Object.assign(this, {
            viewOption: ''
        });
    };
    tslib_1.__decorate([
        observable
    ], NfcTaskFilter.prototype, "viewOption", void 0);
    return NfcTaskFilter;
}());
export default NfcTaskFilter;



//////////////////
// WEBPACK FOOTER
// ./src/pages/nfctask/NfcTaskFilter.tsx
// module id = 376
// module chunks = 0